import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {getAmplitudeViewItemEventProperties} from "../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";
import {trackAmplitudeViewSection} from "../../tracking/amplitude/track_amplitude_view_section";
import {IPersonalizedRecentSearch} from "../types/IPersonalizedHomepage";

/** Section heading as rendered, reused as `item_list_name` for the carousel. */
export const RECENTLY_VIEWED_ITEM_LIST_NAME = "Ostatnio oglądane oferty";

/** Page-level impression of the personalized variant only — never sent for the generic homepage. */
export const trackPersonalizedHomepageViewPage = () => {
    trackAmplitudeEvent("view_page", {
        location: "homepage",
        homepage_variant: "personalized"
    });
};

export const trackPersonalizedHomepageRecentSearchesView = (params: {searches: IPersonalizedRecentSearch[]}) => {
    trackAmplitudeViewSection({
        sectionName: "recent_searches",
        location: "homepage",
        products: params.searches.map(getRecentSearchEventProperties)
    });
};

export const trackPersonalizedHomepageRecentSearchClick = (params: {search: IPersonalizedRecentSearch; index: number}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_recent_search",
        buttonCategory: "homepage",
        itemId: null,
        value: "recent_search",
        additionalEventProperties: getRecentSearchEventProperties(params.search, params.index)
    });
};

export const trackPersonalizedHomepageRecentlyViewedList = (params: {properties: IPropertyDetail[]}) => {
    trackAmplitudeEvent("view_item_list", {
        item_list_id: null,
        item_list_name: RECENTLY_VIEWED_ITEM_LIST_NAME,
        location: "homepage",
        products: params.properties.map((property, index) => getRecentlyViewedEventProperties(property, index))
    });
};

export const trackPersonalizedHomepageRecentlyViewedSelect = (params: {property: IPropertyDetail; index: number}) => {
    trackAmplitudeEvent("select_item", {
        item_list_id: null,
        item_list_name: RECENTLY_VIEWED_ITEM_LIST_NAME,
        location: "homepage",
        ...getRecentlyViewedEventProperties(params.property, params.index)
    });
};

export const trackPersonalizedHomepageOffersForYouClick = (params: {label: string}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_offers_for_you",
        buttonCategory: "homepage",
        itemId: null,
        value: params.label
    });
};

export const trackPersonalizedHomepageYouTubeVideoClick = (params: {videoUrl?: string}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_youtube_video",
        buttonCategory: "homepage",
        itemId: null,
        value: "play_video",
        buttonLink: params.videoUrl ?? null
    });
};

export const trackPersonalizedHomepageYouTubeChannelClick = (params: {label: string; channelUrl: string}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_youtube_channel",
        buttonCategory: "homepage",
        itemId: null,
        value: params.label,
        buttonLink: params.channelUrl
    });
};

export const trackPersonalizedHomepageConsultantCall = (params: {label: string; consultantName: string; phoneNumber: string}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_consultant_call",
        buttonCategory: "homepage",
        itemId: null,
        value: params.label,
        buttonLink: params.phoneNumber,
        additionalEventProperties: {consultant_name: params.consultantName}
    });
};

export const trackPersonalizedHomepagePricesShowMore = (params: {label: string}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_prices_show_more",
        buttonCategory: "homepage",
        itemId: null,
        value: params.label
    });
};

const getRecentSearchEventProperties = (search: IPersonalizedRecentSearch, index: number): Record<string, string | number | null> => ({
    index,
    search_label: search.title,
    rooms_label: search.roomsLabel,
    area_label: search.areaLabel,
    price_label: search.priceLabel,
    new_offers_label: search.newOffersLabel,
    search_recency: search.recencyLabel
});

const getRecentlyViewedEventProperties = (property: IPropertyDetail, index: number) => ({
    ...getAmplitudeViewItemEventProperties({
        offer: property.offer,
        property: {
            id: property.id,
            number: property.number,
            area: property.area,
            rooms: property.rooms,
            floor: property.floor,
            price: property.price
        }
    }),
    ...(property.price_m2 != null ? {price_m2: property.price_m2} : {}),
    index
});
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {getAmplitudeViewItemEventProperties} from "../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";
import {trackAmplitudeViewSection} from "../../tracking/amplitude/track_amplitude_view_section";
import {IPersonalizedRecentSearch} from "../types/IPersonalizedHomepage";

/** Section heading as rendered, reused as `item_list_name` for the carousel. */
export const RECENTLY_VIEWED_ITEM_LIST_NAME = "Ostatnio oglądane oferty";

/** Page-level impression of the personalized variant only — never sent for the generic homepage. */
export const trackPersonalizedHomepageViewPage = () => {
    trackAmplitudeEvent("view_page", {
        location: "homepage",
        homepage_variant: "personalized"
    });
};

export const trackPersonalizedHomepageRecentSearchesView = (params: {searches: IPersonalizedRecentSearch[]}) => {
    trackAmplitudeViewSection({
        sectionName: "recent_searches",
        location: "homepage",
        products: params.searches.map(getRecentSearchEventProperties)
    });
};

export const trackPersonalizedHomepageRecentSearchClick = (params: {search: IPersonalizedRecentSearch; index: number}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_recent_search",
        buttonCategory: "homepage",
        itemId: null,
        value: "recent_search",
        additionalEventProperties: getRecentSearchEventProperties(params.search, params.index)
    });
};

export const trackPersonalizedHomepageRecentlyViewedList = (params: {properties: IPropertyDetail[]}) => {
    trackAmplitudeEvent("view_item_list", {
        item_list_id: null,
        item_list_name: RECENTLY_VIEWED_ITEM_LIST_NAME,
        location: "homepage",
        products: params.properties.map((property, index) => getRecentlyViewedEventProperties(property, index))
    });
};

export const trackPersonalizedHomepageRecentlyViewedSelect = (params: {property: IPropertyDetail; index: number}) => {
    trackAmplitudeEvent("select_item", {
        item_list_id: null,
        item_list_name: RECENTLY_VIEWED_ITEM_LIST_NAME,
        location: "homepage",
        ...getRecentlyViewedEventProperties(params.property, params.index)
    });
};

export const trackPersonalizedHomepageOffersForYouClick = (params: {label: string}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_offers_for_you",
        buttonCategory: "homepage",
        itemId: null,
        value: params.label
    });
};

export const trackPersonalizedHomepageYouTubeVideoClick = (params: {videoUrl?: string}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_youtube_video",
        buttonCategory: "homepage",
        itemId: null,
        value: "play_video",
        buttonLink: params.videoUrl ?? null
    });
};

export const trackPersonalizedHomepageYouTubeChannelClick = (params: {label: string; channelUrl: string}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_youtube_channel",
        buttonCategory: "homepage",
        itemId: null,
        value: params.label,
        buttonLink: params.channelUrl
    });
};

export const trackPersonalizedHomepageConsultantCall = (params: {label: string; consultantName: string; phoneNumber: string}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_consultant_call",
        buttonCategory: "homepage",
        itemId: null,
        value: params.label,
        buttonLink: params.phoneNumber,
        additionalEventProperties: {consultant_name: params.consultantName}
    });
};

export const trackPersonalizedHomepagePricesShowMore = (params: {label: string}) => {
    trackAmplitudeButtonClick({
        buttonName: "rp_homepage_prices_show_more",
        buttonCategory: "homepage",
        itemId: null,
        value: params.label
    });
};

const getRecentSearchEventProperties = (search: IPersonalizedRecentSearch, index: number): Record<string, string | number | null> => ({
    index,
    search_label: search.title,
    rooms_label: search.roomsLabel,
    area_label: search.areaLabel,
    price_label: search.priceLabel,
    new_offers_label: search.newOffersLabel,
    search_recency: search.recencyLabel
});

const getRecentlyViewedEventProperties = (property: IPropertyDetail, index: number) => ({
    ...getAmplitudeViewItemEventProperties({
        offer: property.offer,
        property: {
            id: property.id,
            number: property.number,
            area: property.area,
            rooms: property.rooms,
            floor: property.floor,
            price: property.price
        }
    }),
    ...(property.price_m2 != null ? {price_m2: property.price_m2} : {}),
    index
});
